import { Trans, useLingui } from '@lingui/react/macro';
import { intacctUrls } from '@web/config/env';
import Box from 'carbon-react/lib/components/box';
import Button from 'carbon-react/lib/components/button/__next__';
import Dialog from 'carbon-react/lib/components/dialog';
import Form from 'carbon-react/lib/components/form';
import Typography from 'carbon-react/lib/components/typography';
import type { ComponentPropsWithoutRef } from 'react';
import styled from 'styled-components';

const StyledDialog = styled(Dialog)`
  & [data-component='dialog'] {
    & > div:first-child {
      padding-left: 0;
      padding-top: 0;
      padding-bottom: 0;
      border-radius: 16px;
      & > div:first-child {
        padding-top: 0;
      }
    }
  }
`;

export interface JoinUsModalProps extends ComponentPropsWithoutRef<typeof Dialog> {
  onRemindMeLater: (event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => void;
  onOk: (event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => void;
}

export function JoinUsDialogContent({ onRemindMeLater, onOk, ...dialogProps }: JoinUsModalProps) {
  const { t } = useLingui();
  return (
    <StyledDialog {...dialogProps}>
      <Box display="flex" flexDirection="row" maxHeight="332px">
        <Box>
          <img
            // Avoided multiple buckets since this is a temp component
            style={{ height: '332px' }}
            src="https://qa-sit-assets-public.s3.eu-west-1.amazonaws.com/images/join-us.png"
            alt={t`Join us in Sage Intacct`}
          />
        </Box>
        <Form
          rightSideButtons={
            <Box display="flex" gap={2} mb={2}>
              <Button variantType="secondary" onClick={onRemindMeLater}>
                <Trans>Remind me later</Trans>
              </Button>
              <Button onClick={onOk}>
                <Trans>Got it</Trans>
              </Button>
            </Box>
          }
        >
          <Box pl={4} pt={2}>
            <Typography variant="h1">
              <Trans>Notice: Access Sage Intelligent Time from Sage Intacct</Trans>
            </Typography>
            <Box pt={2}>
              <Typography>
                <Trans>
                  The standalone version of Sage Intelligent Time was officially retired on <strong>September 30, 2025</strong>.
                </Trans>
              </Typography>
              <Typography mb={0}>
                <Trans>
                  To ensure uninterrupted access, please transition to the embedded experience within{' '}
                  <a target="_blank" rel="noreferrer" href={intacctUrls.login}>
                    Sage Intacct
                  </a>{' '}
                  by <strong>October 10, 2025</strong>. Going forward, Sage Intelligent Time must be accessed directly from within{' '}
                  <a target="_blank" rel="noreferrer" href={intacctUrls.login}>
                    Sage Intacct
                  </a>
                  .
                </Trans>
              </Typography>
            </Box>
          </Box>
        </Form>
      </Box>
    </StyledDialog>
  );
}
